var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsAvatarFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0301E;}\n\t.st1{fill:#2D2D2D;}\n\t.st2{fill:#464646;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#7D7D7D;}\n\t.st5{fill:#DB536A;}\n\t.st6{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52,13.5c-19.9,0-36,16.1-36,36c0,9.8,3.9,18.6,10.3,25.1c6.5,6.7,15.7,10.9,25.7,10.9c10.1,0,19.2-4.2,25.8-10.9 C84.1,68.1,88,59.3,88,49.5C88,29.6,71.9,13.5,52,13.5z M69.9,69.7c-5.1-2.2-11.2-3.5-17.9-3.5c-6.7,0-12.8,1.3-17.9,3.5 c-5.6-5-9.1-12.2-9.1-20.2c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C79,57.5,75.5,64.7,69.9,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,33.3c-6.6,0-11.9,5.3-11.9,11.9C40.1,51.7,45.4,57,52,57c6.6,0,11.9-5.3,11.9-11.9C63.9,38.6,58.6,33.3,52,33.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsAvatarFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Avatar_Fill_Black_RGB.93fef093dde66aa5251abc15dbe8565a.svg";
export { ForwardRef as ReactComponent };